import moment from 'moment'

export default class TireDomain {
	/**
	 * Handles the default constructor
	 * @param {string} axleType - adle type
	 * @param {string} priority - priority
	 * @param {string} application - application
	 * @param {string} requiredActivity - required activity
	 * @param {boolean} tireType - tire type (isRetread), true: retread, false: new
	 * @param {string} tireBrand - tire brand
	 * @param {string} tireSize - tire size
	 * @param {string} sizeDesc - tire size description 
	 * @param {string} tread - tread
	 * @param {string} loadRange - load range
	 * @param {number} id - id
	 * @param {string} comments - comments
	 * @param {boolean} isErs - is ERS
	 * @param {boolean} isCreate - in create mode
	 * @param {boolean} isUpdate - in update mode
	 * @param {boolean} isDelete - in delete mode
	 * @param {boolean} isBillToPreference - is this from the bill-to account
	 * @param {number} fleetLocationId - the fleetLocationId or null if a localAccount
	 * @param {boolean} isReadOnly - is this object readOnly
	 * @param {string} createdAt - created date
	 * @param {string} updatedAt - updated date
	 * @returns {TireDomain} - returns the new TireDomain object
	 */
	constructor(axleType, priority, application, requiredActivity, tireType, tireBrand, tireSize, sizeDesc, tread, loadRange, id, fleetLocationId, comments, isErs, isBillToPreference, isReadOnly, createdAt, updatedAt) {
		this.axleType = axleType
		this.priority = priority
		this.application = application ? application : 6
		this.requiredActivity = requiredActivity ? requiredActivity : 'Await Verbal Instruction'
		this.tireType = tireType || false
		this.tireBrand = tireBrand
		this.tireSize = tireSize
		this.sizeDesc = sizeDesc
		this.tread = tread
		this.loadRange = loadRange
		this.id = id
		this.fleetLocationId = fleetLocationId
		this.comments = comments  ? comments : ''
		this.isErs = isErs
		this.isCreate = false
		this.isUpdate = false
		this.isDelete = false
		this.isBillToPreference = isBillToPreference
		this.isReadOnly = isReadOnly
		this.createdAt = moment(createdAt)
		this.updatedAt = moment(updatedAt)
	}
}


// WEBPACK FOOTER //
// ./src/domains/TireDomain.js